import {
  LANGUAGE_CODES,
  LanguageCode,
} from 'src/models/language'
import LanguageSelect from './LanguageSelect'
import { useCallback, useMemo } from 'react'
import { ArrowLeftRight } from 'lucide-react'

const LanguageSelectBar: React.FC<{
  fromLang: LanguageCode
  toLang: LanguageCode
  setFromLang: (l: LanguageCode) => void
  setToLang: (l: LanguageCode) => void
}> = ({ fromLang, toLang, setFromLang, setToLang }) => {
  const toggle = useCallback(() => {
    setFromLang(toLang)
    setToLang(fromLang)
  }, [setFromLang, toLang, setToLang, fromLang])

  const fromOptions = useMemo(
    () => LANGUAGE_CODES.filter((c) => c !== toLang),
    [toLang],
  )
  const toOptions = useMemo(
    () => LANGUAGE_CODES.filter((c) => c !== fromLang),
    [fromLang],
  )

  return (
    <>
      <div className="flex flex-col items-center">
        <p className="mb-2 text-xs text-slate-500">
          Original language
        </p>
        <LanguageSelect
          lang={fromLang}
          backgroundColor="#bd99fe"
          color="white"
          options={fromOptions}
          onValueChange={(l: LanguageCode) =>
            setFromLang(l)
          }
        />
      </div>
      <div
        className="mt-4 cursor-pointer select-none rounded-lg py-2 px-4 transition-all ease-in-out hover:bg-slate-300 hover:text-slate-700"
        onClick={toggle}
      >
        <ArrowLeftRight />
      </div>
      <div className="flex flex-col items-center">
        <p className="mb-2 text-xs text-slate-500">
          Translation
        </p>
        <LanguageSelect
          lang={toLang}
          backgroundColor="#8fe78a"
          color="black"
          options={toOptions}
          onValueChange={(l: LanguageCode) => setToLang(l)}
        />
      </div>
    </>
  )
}

export default LanguageSelectBar
